import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { SecureStorageService } from '../services/secure-storage.service';
import { BreadCrumbService } from '../services/bread-crumb.service';

@Injectable({
  providedIn: 'root'
})
export class ProtectedRoutes implements CanActivate {
  constructor(
    private router: Router,
    private breadCrumbService: BreadCrumbService,
    private secureStorageService: SecureStorageService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const dataMenus = this.secureStorageService.getData("menus") ? JSON.parse(this.secureStorageService.getData("menus") ?? "[]") : false

    if(dataMenus){
    
        const hasAccessAction = dataMenus.some((item: any) => item.action === state.url);

        if (hasAccessAction) {
          this.breadCrumbService.getParentsUntilRoot(state.url)
          return true;
        } else {
            this.router.navigate(['/error/AccessDeniedPage']);
            return false;
        }

    }
    return false
  }
}
